export const OmniLogo = ({ size = 26, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="16" cy="16" r="14.5" stroke="currentColor" strokeWidth="2" />
      <line
        x1="8.5"
        y1="16"
        x2="23.5"
        y2="16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
    <span className="font-display font-bold tracking-[0.18em] text-[0.95rem]">
      OMNI
    </span>
  </span>
);
